import { callAPI } from '../../../services/api.service';
import { HTTPStatusEnum } from '../../../interfaces/log.interface';

export interface CountryOption {
  id: string;
  name: string;
  code: string;
  isDefault: boolean;
  isActive: boolean;
  displayOrder: number;
}

export const getActiveCountries = async (): Promise<CountryOption[]> => {
  try {
    const response = await callAPI('api/countries', null, 'GET');
    if (response?.status === HTTPStatusEnum.OK && Array.isArray(response.data)) {
      return response.data as CountryOption[];
    }
    return [];
  } catch {
    return [];
  }
};

export const getDefaultCountry = async (): Promise<CountryOption | null> => {
  try {
    const response = await callAPI('api/countries/default', null, 'GET');
    if (response?.status === HTTPStatusEnum.OK && response.data) {
      return response.data as CountryOption;
    }
    return null;
  } catch {
    return null;
  }
};
